export const characterNames = [
	"4LOM",
	"50RT",
	"AAYLASECURA",
	"ADMINISTRATORLANDO",
	"ADMIRALACKBAR",
	"ADMIRALPIETT",
	"ADMIRALRADDUS",
	"AHSOKATANO",
	"AMILYNHOLDO",
	"ANAKINKNIGHT",
	"APPO",
	"ARCTROOPER501ST",
	"ARMORER",
	"ASAJJDARKDISCIPLE",
	"ASAJVENTRESS",
	"AURRA_SING",
	"BADBATCHECHO",
	"BADBATCHHUNTER",
	"BADBATCHOMEGA",
	"BADBATCHTECH",
	"BADBATCHWRECKER",
	"B1BATTLEDROIDV2",
	"B2SUPERBATTLEDROID",
	"BARRISSOFFEE",
	"BASTILASHAN",
	"BASTILASHANDARK",
	"BATCHERS3",
	"BAYLANSKOLL",
	"BAZEMALBUS",
	"BB8",
	"BENSOLO",
	"BIGGSDARKLIGHTER",
	"BISHOP",
	"BISTAN",
	"BOBAFETT",
	"BOBAFETTSCION",
	"BODHIROOK",
	"BOKATAN",
	"BOOMADIER",
	"BOSSK",
	"BOSSNASS",
	"BOUSHH",
	"BRUTUS",
	"BT1",
	"C3POCHEWBACCA",
	"C3POLEGENDARY",
	"CADBANE",
	"CALKESTIS",
	"CANDEROUSORDO",
	"CAPTAINDROGAN",
	"CAPTAINENOCH",
	"CAPTAINREX",
	"CAPTAINSILVO",
	"CAPTAINTARPALS",
	"CARADUNE",
	"CARSONTEVA",
	"CARTHONASI",
	"CASSIANANDOR",
	"CASSIANUNDERCOVER",
	"CC2224",
	"CEREJUNDA",
	"CHEWBACCALEGENDARY",
	"CHIEFCHIRPA",
	"CHIEFNEBIT",
	"CHIRRUTIMWE",
	"CHOPPERS3",
	"CINTA",
	"CLONESERGEANTPHASEI",
	"CLONEWARSCHEWBACCA",
	"COBBVANTH",
	"COLONELSTARCK",
	"COMMANDERAHSOKA",
	"COMMANDERLUKESKYWALKER",
	"CORUSCANTUNDERWORLDPOLICE",
	"COUNTDOOKU",
	"CROSSHAIRS3",
	"CT5555",
	"CT7567",
	"CT210408",
	"DAKA",
	"DARKREY",
	"DARKTROOPER",
	"DARTHBANE",
	"DARTHJARJAR",
	"DARTHMALAK",
	"DARTHMALGUS",
	"DARTHNIHILUS",
	"DARTHREVAN",
	"DARTHSIDIOUS",
	"DARTHSION",
	"DARTHTALON",
	"DARTHTRAYA",
	"DASHRENDAR",
	"DATHCHA",
	"DEATHTROOPER",
	"DEATHTROOPERPERIDEA",
	"DEDRAMEERO",
	"DENGAR",
	"DEPABILLABA",
	"DIRECTORKRENNIC",
	"DISGUISEDCLONETROOPER",
	"DOCTORAPHRA",
	"DROIDEKA",
	"EETHKOTH",
	"EIGHTHBROTHER",
	"EMBO",
	"EMPERORPALPATINE",
	"ENFYSNEST",
	"EPIXFINN",
	"EPIXPOE",
	"EWOKELDER",
	"EWOKSCOUT",
	"EZRABRIDGERS3",
	"EZRAEXILE",
	"FENNECSHAND",
	"FIFTHBROTHER",
	"FINN",
	"FIRSTORDEREXECUTIONER",
	"FIRSTORDEROFFICERMALE",
	"FIRSTORDERSPECIALFORCESPILOT",
	"FIRSTORDERTIEPILOT",
	"FIRSTORDERTROOPER",
	"FOSITHTROOPER",
	"FULCRUMAHSOKA",
	"GAMORREANGUARD",
	"GARSAXON",
	"GENERALHUX",
	"GENERALKENOBI",
	"GENERALSKYWALKER",
	"GENERALSYNDULLA",
	"GEONOSIANBROODALPHA",
	"GEONOSIANSOLDIER",
	"GEONOSIANSPY",
	"GLAHSOKATANO",
	"GLHONDO",
	"GLLEIA",
	"GLREY",
	"GOPHERANTS",
	"GRANDADMIRALTHRAWN",
	"GRANDINQUISITOR",
	"GRANDMASTERLUKE",
	"GRANDMASTERYODA",
	"GRANDMOFFTARKIN",
	"GREATMOTHERS",
	"GREEDO",
	"GREEFKARGA",
	"GRIEVOUS",
	"GUNGANPHALANX",
	"HANSOLO",
	"HERASYNDULLAS3",
	"HERMITYODA",
	"HK47",
	"HONDO",
	"HOTHHAN",
	"HOTHLEIA",
	"HOTHREBELSCOUT",
	"HOTHREBELSOLDIER",
	"HUMANTHUG",
	"HUNTERS3",
	"HUYANG",
	"IDENVERSIOEMPIRE",
	"IG11",
	"IG12",
	"IG86SENTINELDROID",
	"IG88",
	"IG90",
	"IMAGUNDI",
	"IMPERIALPROBEDROID",
	"IMPERIALSUPERCOMMANDO",
	"INQUISITORBARRISS",
	"ITHANO",
	"JABBATHEHUTT",
	"JANGOFETT",
	"JARJARBINKS",
	"JAWA",
	"JAWAENGINEER",
	"JAWASCAVENGER",
	"JAXXON",
	"JEDIKNIGHTCAL",
	"JEDIKNIGHTCONSULAR",
	"JEDIKNIGHTGUARDIAN",
	"JEDIKNIGHTLUKE",
	"JEDIKNIGHTREVAN",
	"JEDIMASTERKENOBI",
	"JEDIMASTERMACEWINDU",
	"JOCASTANU",
	"JOLEEBINDO",
	"JUHANI",
	"JYNERSO",
	"K2SO",
	"KANANJARRUSS3",
	"KELLERANBEQ",
	"KIADIMUNDI",
	"KITFISTO",
	"KIX",
	"KLEYA",
	"KRRSANTAN",
	"KUIIL",
	"KXSECURITYDROID",
	"KYLEKATARN",
	"KYLOREN",
	"KYLORENUNMASKED",
	"L3_37",
	"LEIAJEDITRAINING",
	"LOBOT",
	"LOGRAY",
	"LORDVADER",
	"LUKESKYWALKER",
	"LUKESTARKILLER",
	"LUMINARAUNDULI",
	"LUTHENRAEL",
	"MACEWINDU",
	"MAGMATROOPER",
	"MAGNAGUARD",
	"MAJORPARTAGAZ",
	"MANDALORBOKATAN",
	"MARAJADE",
	"MARAJADESKYWALKER",
	"MARROK",
	"MASTERQUIGON",
	"MAUL",
	"MAULHATEFUELED",
	"MAULS7",
	"MAZKANATA",
	"MERRIN",
	"MISSIONVAO",
	"MOFFGIDEONS1",
	"MOFFGIDEONS3",
	"MONMOTHMA",
	"MORGANELSBETH",
	"MOTHERTALZIN",
	"NIGHTSISTERACOLYTE",
	"NIGHTSISTERINITIATE",
	"NIGHTSISTERSPIRIT",
	"NIGHTSISTERZOMBIE",
	"NIGHTTROOPER",
	"NINTHSISTER",
	"NUTEGUNRAY",
	"OLDBENKENOBI",
	"OMEGAS3",
	"OPERATIVE",
	"PADAWANOBIWAN",
	"PADAWANSABINE",
	"PADMEAMIDALA",
	"PAO",
	"PAPLOO",
	"PAZVIZSLA",
	"PHASMA",
	"PLOKOON",
	"POE",
	"POGGLETHELESSER",
	"PRINCESSKNEESAA",
	"PRINCESSLEIA",
	"QIRA",
	"QUEENAMIDALA",
	"QUIGGOLD",
	"QUIGONJINN",
	"R2D2_LEGENDARY",
	"R5D4",
	"RACCOON",
	"RANGERZEB",
	"RANGETROOPER",
	"REMNANTSNOWCOMMANDER",
	"RESISTANCEPILOT",
	"RESISTANCETROOPER",
	"REY",
	"REYJEDITRAINING",
	"ROSETICO",
	"ROYALGUARD",
	"SABINEWRENS3",
	"SANASTARROS",
	"SATELESHAN",
	"SAVAGEOPRESS",
	"SAWGERRERA",
	"SCARIFREBEL",
	"SCORCH",
	"SCOUTTROOPER_V3",
	"SECONDSISTER",
	"SEVENTHSISTER",
	"SHAAKTI",
	"SHINHATI",
	"SHORETROOPER",
	"SITHASSASSIN",
	"SITHMARAUDER",
	"SITHPALPATINE",
	"SITHTROOPER",
	"SM33",
	"SMUGGLERCHEWBACCA",
	"SMUGGLERHAN",
	"SNOWTROOPER",
	"STAP",
	"STARKILLER",
	"STORMTROOPER",
	"STORMTROOPERCONCEPT",
	"STORMTROOPERHAN",
	"STORMTROOPERLUKE",
	"STRANGER",
	"SUNFAC",
	"SUPREMELEADERKYLOREN",
	"T3_M4",
	"TALIA",
	"TARFFUL",
	"TARONMALICOS",
	"TEEBO",
	"THEMANDALORIAN",
	"THEMANDALORIANBESKARARMOR",
	"THERONIN",
	"THIRDSISTER",
	"TIEFIGHTERPILOT",
	"TRENCH",
	"TRIPLEZERO",
	"TUSKENCHIEFTAIN",
	"TUSKENHUNTRESS",
	"TUSKENRAIDER",
	"TUSKENSHAMAN",
	"UGNAUGHT",
	"UNDERCOVERLANDO",
	"URORRURRR",
	"VADER",
	"VADERDUELSEND",
	"VANE",
	"VANGUARDTEMPLEGUARD",
	"VEERS",
	"VEL",
	"VISASMARR",
	"WAMPA",
	"WATTAMBOR",
	"WEDGEANTILLES",
	"WICKET",
	"WRECKERS3",
	"YODACHEWBACCA",
	"YODADSV",
	"YOUNGCHEWBACCA",
	"YOUNGHAN",
	"YOUNGLANDO",
	"ZAALBAR",
	"ZAMWESELL",
	"ZEBS3",
	"ZORIIBLISS_V2",
	"ZUCKUSS",
] as const;

export type CharacterNames = string;
